import { fetchApi } from '@/config/axiosSetting';
import { IPatchBodyWagesParams } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyWages/patchBodyWages.type';

export const patchBodyWagesQueryFunction = (params: IPatchBodyWagesParams) =>
  fetchApi.patch(
    `body/reports/${params?.id}/accident_users/damaged/adjusting/wages/`,
    params.data,
    {
      params: {
        source: params.source,
        wages_id: params.wages_id,
      },
    },
  );
